import { Observable } from 'rxjs';
import { endWith } from 'rxjs/operators';
import { unsafeCast } from '../utils';
import { flatMap } from 'rxjs/internal/operators';
import { ParametricViewer } from './types';

export * from './types';
export * from './use-shape-diver';
export * from './utils';

/**
 * Emits single value when the ShapeDiver is loaded and ready to be used, and
 * then completes.
 */
export const shapeDiverLoaded$: Observable<boolean> = new Observable<boolean>(
  (s) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => s.complete(), false);
    } else {
      s.complete();
    }
  }
).pipe(endWith(true));

/**
 * Initializes ShapeDiver viewer and waits for it to load the given model.
 * Observable emits the viewer object, when it is ready, and completes.
 *
 * @param ticket - shape diver model id
 * @param container - the div which will hold the 3D model
 */
export function initializeViewer(
  ticket: string,
  container: HTMLElement
): Observable<ParametricViewer> {
  const viewer$ = new Observable<ParametricViewer>((s) => {
    const settings = {
      container: unsafeCast(container),
      ticket,
      modelViewUrl: 'eu-central-1',
    };

    const viewer = new SDVApp.ParametricViewer(settings);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).sdViewer = viewer;

    const addIdleListenerResponse = viewer.state.addEventListener(
      viewer.state.EVENTTYPE.IDLE,
      () => {
        viewer.state.removeEventListener(addIdleListenerResponse.data[0]);
        s.next(viewer);
        s.complete();
      }
    );

    const addErrorListenerResponse = viewer.state.addEventListener(
      viewer.state.EVENTTYPE.FAILED,
      () => {
        console.log('error listener', addErrorListenerResponse);
        viewer.state.removeEventListener(addErrorListenerResponse.data[0]);
        s.next(viewer);
        s.error(new Error('Wrong ticket id!'));
      }
    );
  });

  return shapeDiverLoaded$.pipe(flatMap(() => viewer$));
}
